import React, { Component } from "react";
import Layout from "./Layout";
import DashboardViews from "../views/Dashboard";
import { Redirect } from "react-router-dom";
import $ from 'jquery'

let offertypeVal;
let mediumVal;
class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dashboard: {
        data: [],
        defaultData: [],
        dataLoad: false,
        filterValue: "current-day",
        activeFilter: false,
        activeEle: null,
        loading: true,
        value: 0
      },
      dashboardReport: {
        selectedOption: { label: 'Select Report', value: 'Select Report' },
        reportdateOption: false,
        open: true,
        daterangeoption: { label: 'Yesterday', value: 'Yesterday' },
        startDate: new Date(),
        endDate: new Date(),
        error_msg: false,
        medium: [],
        medium_: [],
        offerType: [],
        offer_Type: [],
        sourceList: [],
        source_List: [],
        reportList: [],
        dollarCost: [],
        dollar_Cost: [],
        source_Provider: '',
        lead_Return_Reason_List: [],
        leadReturnReason: '',
        selectMonth: new Date(),
        isReportVisible: false,
        currentPage: 1,
        loading: true,
        page: 1,
        reportresults: {},
      },
      chartColumns: [
        { type: 'date', label: 'Months' },
        { type: 'number', label: 'Acepted Leads' },
        { type: 'number', label: 'Your Revenue' }
      ]
    };
    this.loadOptions = this.loadOptions.bind(this);
    this.dashboardRequest = this.dashboardRequest.bind(this)
  }


  loadOptions() {
    let get_token = localStorage.getItem("token");
    let requestofferOptions = {
      method: "GET",
      mode: "cors",
      headers: {
        'Authorization': 'Bearer' + get_token,
      },
    };
    let tokenrequestOtions = {
      method: "POST",
      mode: "cors",
      headers: {
        'Authorization': 'Bearer' + get_token,
      },
    };


    fetch(`./wp-json/asd/api/offer_type`, requestofferOptions)
      .then(response => response.json())
      .then(data => { this.setState({ dashboardReport: { ...this.state.dashboardReport, offer_Type: data.data } }); })
      .catch(error => { console.error(error) })

    fetch(`./wp-json/asd/api/source`, tokenrequestOtions)
      .then(response => response.json())
      .then(data => { this.setState({ dashboardReport: { ...this.state.dashboardReport, source_List: data.data } }); })
      .catch(error => { console.error(error) })

    fetch(`./wp-json/asd/api/medium`, tokenrequestOtions)
      .then(response => response.json())
      .then(data => { this.setState({ dashboardReport: { ...this.state.dashboardReport, medium_: data.data } }); })
      .catch(error => { console.error(error) })

    fetch(`./wp-json/asd/api/dollar_cost`, tokenrequestOtions)
      .then(response => response.json())
      .then(data => { this.setState({ dashboardReport: { ...this.state.dashboardReport, dollar_Cost: data.data } }); })
      .catch(error => { console.error(error) })
    
    fetch(`./wp-json/asd/api/lead_return`, requestofferOptions)
      .then(response => response.json())
      .then(data => { this.setState({ dashboardReport: { ...this.state.dashboardReport, lead_Return_Reason_List: data.data } }); })
      .catch(error => { console.error(error) })
  }

  dashboardRequest() {
    const tabactive = Number(localStorage.getItem("value"))
    const get_token = localStorage.getItem("token");
    const inpersonateFlag = localStorage.getItem("inpersonate");


    localStorage.setItem('SaveSubscription', 0);

    const requestOptions = {
      method: "POST",
      mode: "cors",
      body: JSON.stringify({
        get_token: get_token,
        dateRange: "current-day"
      })
    };

    this.setState({
      dashboard: {
        activeFilter: true,
        loading: true,
      }
    });

    if (tabactive === 0) {
      fetch(`./wp-json/asd/dashboard/data`, requestOptions)
        .then(response => response.json())
        .then(data => {
          if (
            "jwt_auth_invalid_token" === data.code ||
            "jwt_auth_bad_iss" === data.code
          ) {
            localStorage.removeItem("token");
            window.location.href = "/asd-login";
          } else if (data.asdError || "jwt_auth_bad_request" === data.code) {
            if (data.asdError) {
              alert(data.asdError);
            } else {
              alert(data.message);
            }
          } else if (data != null && data.length > 0) {
            this.setState({
              dashboard: {
                data: data,
                dataLoad: true,
                loading: false
              }
            });
          } else {
            this.setState({
              dashboard: {
                defaultData: data,
                dataLoad: true,
                loading: false
              }
            });


          }
        })
        .catch(error => { console.error(error) })

      const requestofferOptions = {
        method: "GET",
        mode: "cors",
        headers: {
          'Authorization': 'Bearer' + get_token,
        },
      };
      const tokenrequestOtions = {
        method: "POST",
        mode: "cors",
        headers: {
          'Authorization': 'Bearer' + get_token,
        },
      };

      const requestOption = {
        method: "POST",
        mode: "cors",
        headers: {
          'Authorization': 'Bearer' + get_token,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ token: get_token }),
      };

      fetch(`./wp-json/asd/api/offer_type`, requestofferOptions)
        .then(response => response.json())
        .then(data => { this.setState({ dashboardReport: { ...this.state.dashboardReport, offer_Type: data.data } }); })
        .catch(error => { console.error(error) })

      fetch(`./wp-json/asd/api/source`, tokenrequestOtions)
        .then(response => response.json())
        .then(data => { this.setState({ dashboardReport: { ...this.state.dashboardReport, source_List: data.data } }); })
        .catch(error => { console.error(error) })

      fetch(`./wp-json/asd/api/medium`, tokenrequestOtions)
        .then(response => response.json())
        .then(data => { this.setState({ dashboardReport: { ...this.state.dashboardReport, medium_: data.data } }); })
        .catch(error => { console.error(error) })

      fetch(`./wp-json/asd/api/dollar_cost`, tokenrequestOtions)
        .then(response => response.json())
        .then(data => { this.setState({ dashboardReport: { ...this.state.dashboardReport, dollar_Cost: data.data } }); })
        .catch(error => { console.error(error) })

      fetch(`./wp-json/asd/api/report_list`, requestOption)
        .then(response => response.json())
        .then(data => { this.setState({ dashboardReport: { ...this.state.dashboardReport, reportList: data.data } }); })
        .catch(error => { console.error(error) })
    
      if (inpersonateFlag == 'true') {
        const inpersonateUser = localStorage.getItem("inpersonate_user");
        const inpersonateUserid = localStorage.getItem("inpersonate_id");
        const sourcerequestOptions = {
          method: 'POST',
          mode: 'cors',
          body: JSON.stringify({ id: inpersonateUserid, token: get_token }),
        };
        fetch(`./wp-json/asd/users/get`, sourcerequestOptions)
          .then(response => response.json())
          .then(data => { this.setState({ dashboardReport: { ...this.state.dashboardReport, source_Provider: data.user_code } }) })
          .catch(error => { console.error(error) })
      }
      else {
        const userId = localStorage.getItem("userId");
        if (userId !== '' && userId !== null) {
          const sourcerequestOptions = {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify({ id: userId, token: get_token }),
          };
          fetch(`./wp-json/asd/users/get`, sourcerequestOptions)
            .then(response => response.json())
            .then(data => { this.setState({ dashboardReport: { ...this.state.dashboardReport, source_Provider: data.user_code } }) })
            .catch(error => { console.error(error) })
        }
      }
      /* Report Data*/
      if (this.state.dashboardReport.selectedOption.value != "Select Report") {
      }

    }

  }

  componentDidMount() {
    this.dashboardRequest();

  }

  render() {
    const isAlreadyAuthenticated = localStorage.getItem("token");
    const chartFilter = (event, newValue) => {

      var oldActiveElement = document.querySelector('.bg-orange:not(.menu-list-item )');
      if (oldActiveElement != null) {
        oldActiveElement.classList.remove('bg-orange');
      }
      var newActiveElement = event.target;
      newActiveElement.classList.add('bg-orange');
      this.setState({
        dashboard: {
          filterValue: event.currentTarget.id,
          activeFilter: true,
          activeEle: newActiveElement,
          loading: true
        }
      });
      const get_token = localStorage.getItem("token");

      const requestOptions_2 = {
        method: "POST",
        mode: "cors",
        body: JSON.stringify({
          get_token: get_token,
          dateRange: event.currentTarget.id
        })
      };

      fetch(`./wp-json/asd/dashboard/data`, requestOptions_2)
        .then(response => response.json())
        .then(data => {
          if (
            "jwt_auth_invalid_token" === data.code ||
            "jwt_auth_bad_iss" === data.code
          ) {
            localStorage.removeItem("token");
            window.location.href = "/asd-login";
          } else if (
            data.asdError ||
            "jwt_auth_bad_request" === data.code ||
            "http_request_failed" == data.code
          ) {
            if (data.asdError) {
              alert(data.asdError);
            } else {
              alert(data.message);
            }
            var oldActiveElement = document.querySelector('.bg-orange:not(.menu-list-item )');
            if (oldActiveElement != null) {
              oldActiveElement.classList.remove('bg-orange');
            }

            newActiveElement.classList.add('bg-orange');
            this.setState({
              dashboard: {
                loading: false
              }
            });
          } else if (data != null && data.length > 0) {
            var oldActiveElement = document.querySelector('.bg-orange:not(.menu-list-item )');
            if (oldActiveElement != null) {
              oldActiveElement.classList.remove('bg-orange');
            }

            newActiveElement.classList.add('bg-orange');

            this.setState({
              dashboard: {
                data: data,
                dataLoad: true,
                activeFilter: newActiveElement.className,
                activeEle: newActiveElement,
                loading: false
              }
            });
          } else {
            var oldActiveElement = document.querySelector('.bg-orange:not(.menu-list-item )');
            if (oldActiveElement != null) {
              oldActiveElement.classList.remove('bg-orange');
            }

            newActiveElement.classList.add('bg-orange');

            this.setState({
              dashboard: {
                defaultData: data,
                dataLoad: true,
                activeFilter: newActiveElement.className,
                activeEle: newActiveElement,
                loading: false
              }
            });


          }
        })
        .catch(error => { console.error(error) })
    };

    const handleChange = selectedOption => {
      this.loadOptions();
      this.setState({ dashboardReport: { ...this.state.dashboardReport, selectedOption: selectedOption } });
      if (['interaday_external_partner_lead_detailed_report', 'intraday_linkout_lead_detail_report'].includes(selectedOption.value)) {
        this.setState({ dashboardReport: { ...this.state.dashboardReport, selectedOption: selectedOption, isReportVisible: false, medium: [], sourceList: [], offerType: [], daterangeoption: { label: 'Today', value: 'Today' } } });
      } else if (selectedOption.value == 'unique_student_report') {
        let y_date = new Date(new Date().setDate(new Date().getDate() - 1));
        $('.datepicker').addClass("disabled");
        let dt = new Date();
        dt.setDate(1);
        dt.setMonth(dt.getMonth() - 2);
        this.setState({ dashboardReport: { ...this.state.dashboardReport, startDate: y_date, selectMonth: dt, endDate: y_date, selectedOption: selectedOption, isReportVisible: false, medium: [], sourceList: [], offerType: [], daterangeoption: { label: 'Yesterday', value: 'Yesterday' } } });

      } else {
        let dt = new Date();
        let y_date = new Date(new Date().setDate(new Date().getDate() - 1));
        $('.datepicker').addClass("disabled");
        this.setState({ dashboardReport: { ...this.state.dashboardReport, startDate: y_date, selectMonth: dt, endDate: y_date, selectedOption: selectedOption, isReportVisible: false, medium: [], sourceList: [], offerType: [], daterangeoption: { label: 'Yesterday', value: 'Yesterday' } } });

      }

    };

    const togglePanel = () => {
      this.setState({ dashboardReport: { ...this.state.dashboardReport, open: !this.state.dashboardReport.open } });
    }
    const presentDatehandleChange = daterangeoption => {
      this.setState({ dashboardReport: { ...this.state.dashboardReport, daterangeoption: daterangeoption, error_msg: false } }, () => {
        this.setState({ dashboardReport: { ...this.state.dashboardReport, error_msg: false } })
      });
      if (daterangeoption.value == 'Custom') {
        this.setState({ dashboardReport: { ...this.state.dashboardReport, startDate: new Date(), endDate: new Date(), daterangeoption: daterangeoption } });
      }
      else if (daterangeoption.value == 'Today') {
        $('#formElem').removeClass("disabled");
        $('.datepicker').addClass("disabled");
        this.setState({ dashboardReport: { ...this.state.dashboardReport, startDate: new Date(), endDate: new Date(), daterangeoption: daterangeoption } });
      }
      else if (daterangeoption.value == 'Yesterday') {
        $('#formElem').removeClass("disabled");
        let y_date = new Date(new Date().setDate(new Date().getDate() - 1));
        this.setState({ dashboardReport: { ...this.state.dashboardReport, startDate: y_date, endDate: y_date, daterangeoption: daterangeoption } });

      }
      else if (daterangeoption.value == 'Last 7 days') {
        this.setState({ error_msg: false });
        $('#formElem').removeClass("disabled");
        let lastseven_date = new Date(new Date().setDate(new Date().getDate() - 7));
        this.setState({ dashboardReport: { ...this.state.dashboardReport, startDate: lastseven_date, endDate: new Date(new Date().setDate(new Date().getDate() - 1)), daterangeoption: daterangeoption } });
      }
      else if (daterangeoption.value == 'Last 30 days') {
        this.setState({ error_msg: false });
        $('#formElem').removeClass("disabled");
        let lastthirty_date = new Date(new Date().setDate(new Date().getDate() - 30));
        this.setState({ dashboardReport: { ...this.state.dashboardReport, startDate: lastthirty_date, endDate: new Date(new Date().setDate(new Date().getDate() - 1)), daterangeoption: daterangeoption } });

      }
      else if (daterangeoption.value == 'Last 60 days') {
        this.setState({ error_msg: false });
        $('#formElem').removeClass("disabled");
        let lastthirty_date = new Date(new Date().setDate(new Date().getDate() - 60));
        this.setState({ dashboardReport: { ...this.state.dashboardReport, startDate: lastthirty_date, endDate: new Date(new Date().setDate(new Date().getDate() - 1)), daterangeoption: daterangeoption } });
      }
      else if (daterangeoption.value == 'Last 90 days') {
        this.setState({ error_msg: false });
        $('#formElem').removeClass("disabled");
        let lastninty_date = new Date(new Date().setDate(new Date().getDate() - 90));
        this.setState({ dashboardReport: { ...this.state.dashboardReport, startDate: lastninty_date, endDate: new Date(new Date().setDate(new Date().getDate() - 1)), daterangeoption: daterangeoption } });

      }
      else if (daterangeoption.value == 'This week') {
        this.setState({ error_msg: false });
        $('#formElem').removeClass("disabled");
        var curr = new Date;
        var firstday = new Date(curr.setDate(curr.getDate() - curr.getDay()));
        var lastday = new Date(curr.setDate(curr.getDate() - curr.getDay() + 6));
        this.setState({ dashboardReport: { ...this.state.dashboardReport, startDate: firstday, endDate: new Date(new Date().setDate(new Date().getDate() - 1)), daterangeoption: daterangeoption } });
      }
      else if (daterangeoption.value == 'Last week') {
        this.setState({ error_msg: false });
        $('#formElem').removeClass("disabled");
        var beforeOneWeek = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000)
        var beforeOneWeek2 = new Date(beforeOneWeek);
        var day = beforeOneWeek.getDay() + 1;
        var diffToMonday = beforeOneWeek.getDate() - day + (day === 0 ? -6 : 1);
        var lastMonday = new Date(beforeOneWeek.setDate(diffToMonday))
        var lastSunday = new Date(beforeOneWeek2.setDate(diffToMonday + 6));
        this.setState({ dashboardReport: { ...this.state.dashboardReport, startDate: lastMonday, endDate: lastSunday, daterangeoption: daterangeoption } });

      }
      else if (daterangeoption.value == 'This Month') {
        this.setState({ error_msg: false });
        $('#formElem').removeClass("disabled");
        var date = new Date();
        var firstMDay = new Date(date.getFullYear(), date.getMonth(), 1);
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        this.setState({ dashboardReport: { ...this.state.dashboardReport, startDate: firstMDay, endDate: new Date(new Date().setDate(new Date().getDate() - 1)), daterangeoption: daterangeoption } });

      }
      else if (daterangeoption.value == 'Last Month') {
        this.setState({ error_msg: false });
        $('#formElem').removeClass("disabled");
        var now = new Date();
        var lastsday = new Date(now.getFullYear(), now.getMonth(), 0);
        var firstsday = new Date(lastsday.getFullYear(), lastsday.getMonth(), 1);
        this.setState({ dashboardReport: { ...this.state.dashboardReport, startDate: firstsday, endDate: lastsday, daterangeoption: daterangeoption } });


      }
      else {
        $('.custom-date-lbl').addClass('lbl-hide');

      }
    };
    const handleMonthChange = (monthName, monthValue) => {
      if (monthValue) {
        if (monthName === 'selectMonth') {
          this.state.dashboardReport.selectMonth = monthValue;
        }
        this.setState({ dashboardReport: { ...this.state.dashboardReport, selectMonth: this.state.dashboardReport.selectMonth } });
      }

    }
    const handleDateChange = (dateName, dateValue) => {
      if (dateName === 'startDateTime') {
        this.state.dashboardReport.startDate = dateValue;
      } else {
        this.state.dashboardReport.endDate = dateValue;
      }
      this.setState({ dashboardReport: { ...this.state.dashboardReport, startDate: this.state.dashboardReport.startDate, endDate: this.state.dashboardReport.endDate } });

      if (Date.parse(this.state.dashboardReport.startDate) > Date.parse(this.state.dashboardReport.endDate)) {
        this.setState({ dashboardReport: { ...this.state.dashboardReport, error_msg: true } });
        $('#formElem').addClass("disabled");
      }
      else {
        this.setState({ dashboardReport: { ...this.state.dashboardReport, error_msg: false } });
        $('#formElem').removeClass("disabled");
      }
    }
    const mediumhandleChange = (medium) => {
      if (!medium) {
        medium = [];
      }
      if (medium.length == 0 && (this.state.dashboardReport.selectedOption.value === 'external_partner_lead_summary_report' || this.state.dashboardReport.selectedOption.value === 'external_partner_lead_detailed_report' || this.state.dashboardReport.selectedOption.value === 'interaday_external_partner_lead_detailed_report' || this.state.dashboardReport.selectedOption.value === 'real_time_lead_reject_reason') && this.state.dashboardReport.sourceList.length == 0) {
        let get_token = localStorage.getItem("token");
        let sourceVal = $('.hidden-lbl.source-lbl').text();
        let objArr = {}
        if ((sourceVal.trim()) != "") {
          objArr = { ['source']: sourceVal.trim() }
        }
        let tokenrequestOtions = {
          method: "POST",
          mode: "cors",
          headers: {
            'Authorization': 'Bearer' + get_token,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(objArr),
        };
        fetch(`./wp-json/asd/api/medium`, tokenrequestOtions)
          .then(response => response.json())
          .then(data => { this.setState({ dashboardReport: { ...this.state.dashboardReport, medium_: data.data } }); })
          .catch(error => { console.error(error) })
      }
      this.setState({ dashboardReport: { ...this.state.dashboardReport, medium: medium } }, () => {
        if ((this.state.dashboardReport.selectedOption.value === 'external_partner_lead_summary_report' || this.state.dashboardReport.selectedOption.value === 'external_partner_lead_detailed_report' || this.state.dashboardReport.selectedOption.value === 'interaday_external_partner_lead_detailed_report' || this.state.dashboardReport.selectedOption.value === 'real_time_lead_reject_reason') && this.state.dashboardReport.sourceList.length == 0) {
          console.log(this.state.dashboardReport.sourceList);
          let get_token = localStorage.getItem("token");
          let mediumVal = $('.hidden-lbl.medium-lbl').text();
          let objArr = {}
          if ((mediumVal.trim()) != "") {
            objArr = { ['medium']: mediumVal.trim() }
          }
          let tokenrequestOtions = {
            method: "POST",
            mode: "cors",
            headers: {
              'Authorization': 'Bearer' + get_token,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(objArr),
          };
          fetch(`./wp-json/asd/api/source`, tokenrequestOtions)
            .then(response => response.json())
            .then(data => { this.setState({ dashboardReport: { ...this.state.dashboardReport, source_List: data.data } }); })
            .catch(error => { console.error(error) })
        }
      });
    };
    const offertypehandleChange = (offerType) => {
      if (!offerType) {
        offerType = [];
      }
      this.setState({ dashboardReport: { ...this.state.dashboardReport, offerType: offerType } });
    };

    const dollarCosthandleChange = (dollarCost) => {
      if (!dollarCost) {
        dollarCost = [];
      }
      if (dollarCost.length == 0 && this.state.dashboardReport.sourceList.length == 0) {
        let get_token = localStorage.getItem("token");
        let sourceVal = $('.hidden-lbl.source-lbl').text();
        let objArr = {}
        if ((sourceVal.trim()) != "") {
          objArr = { ['source']: sourceVal.trim() }
        }
        let tokenrequestOtions = {
          method: "POST",
          mode: "cors",
          headers: {
            'Authorization': 'Bearer' + get_token,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(objArr),
        };
        fetch(`./wp-json/asd/api/dollar_cost`, tokenrequestOtions)
          .then(response => response.json())
          .then(data => { this.setState({ dashboardReport: { ...this.state.dashboardReport, dollar_Cost: data.data } }); })
          .catch(error => { console.error(error) })
      }
      this.setState({ dashboardReport: { ...this.state.dashboardReport, dollarCost: dollarCost } }, () => {
        if ((this.state.dashboardReport.selectedOption.value === 'unique_student_report') && this.state.dashboardReport.sourceList.length == 0) {
          console.log(this.state.dashboardReport.sourceList);
          let get_token = localStorage.getItem("token");
          let dollarVal = $('.hidden-lbl.dollar-lbl').text();
          let objArr = {}
          if ((dollarVal.trim()) != "") {
            objArr = { ['dollar_cost']: dollarVal.trim() }
          }
          let tokenrequestOtions = {
            method: "POST",
            mode: "cors",
            headers: {
              'Authorization': 'Bearer' + get_token,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(objArr),
          };
          fetch(`./wp-json/asd/api/source`, tokenrequestOtions)
            .then(response => response.json())
            .then(data => { this.setState({ dashboardReport: { ...this.state.dashboardReport, source_List: data.data } }); })
            .catch(error => { console.error(error) })
        }
      });
    };

    const sourcehandleChange = (sourceType) => {
      if (!sourceType) {
        sourceType = [];
      }
      console.log(sourceType)
      if (sourceType.length == 0 && this.state.dashboardReport.medium.length == 0 && (this.state.dashboardReport.selectedOption.value === 'external_partner_lead_summary_report' || this.state.dashboardReport.selectedOption.value === 'external_partner_lead_detailed_report' || this.state.dashboardReport.selectedOption.value === 'interaday_external_partner_lead_detailed_report' || this.state.dashboardReport.selectedOption.value === 'real_time_lead_reject_reason')) {
        let get_token = localStorage.getItem("token");
        let mediumVal = $('.hidden-lbl.medium-lbl').text();
        let objArr = {}
        if ((mediumVal.trim()) != "") {
          objArr = { ['medium']: mediumVal.trim() }
        }
        let tokenrequestOtions = {
          method: "POST",
          mode: "cors",
          headers: {
            'Authorization': 'Bearer' + get_token,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(objArr),
        };
        fetch(`./wp-json/asd/api/source`, tokenrequestOtions)
          .then(response => response.json())
          .then(data => { this.setState({ dashboardReport: { ...this.state.dashboardReport, source_List: data.data } }); })
          .catch(error => { console.error(error) })
      }
      if (sourceType.length == 0 && this.state.dashboardReport.dollarCost.length == 0 && this.state.dashboardReport.selectedOption.value === 'unique_student_report') {
        let get_token = localStorage.getItem("token");
        let mediumVal = $('.hidden-lbl.medium-lbl').text();
        let objArr = {}
        if ((mediumVal.trim()) != "") {
          objArr = { ['medium']: mediumVal.trim() }
        }
        let tokenrequestOtions = {
          method: "POST",
          mode: "cors",
          headers: {
            'Authorization': 'Bearer' + get_token,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(objArr),
        };
        fetch(`./wp-json/asd/api/source`, tokenrequestOtions)
          .then(response => response.json())
          .then(data => { this.setState({ dashboardReport: { ...this.state.dashboardReport, source_List: data.data } }); })
          .catch(error => { console.error(error) })
      }
      this.setState({ dashboardReport: { ...this.state.dashboardReport, sourceList: sourceType } }, () => {
        if ((this.state.dashboardReport.selectedOption.value === 'unique_student_report') && this.state.dashboardReport.dollarCost.length == 0) {
          let get_token = localStorage.getItem("token");
          let sourceVal = $('.hidden-lbl.source-lbl').text();
          let objArr = {}
          if ((sourceVal.trim()) != "") {
            objArr = { ['source']: sourceVal.trim() }
          }
          let tokenrequestOtions = {
            method: "POST",
            mode: "cors",
            headers: {
              'Authorization': 'Bearer' + get_token,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(objArr),
          };
          fetch(`./wp-json/asd/api/dollar_cost`, tokenrequestOtions)
            .then(response => response.json())
            .then(data => { this.setState({ dashboardReport: { ...this.state.dashboardReport, dollar_Cost: data.data } }); })
            .catch(error => { console.error(error) })
        } else if ((this.state.dashboardReport.selectedOption.value === 'external_partner_lead_summary_report' || this.state.dashboardReport.selectedOption.value === 'external_partner_lead_detailed_report' || this.state.dashboardReport.selectedOption.value === 'interaday_external_partner_lead_detailed_report' || this.state.dashboardReport.selectedOption.value === 'real_time_lead_reject_reason') && this.state.dashboardReport.medium.length == 0) {
          let get_token = localStorage.getItem("token");
          let sourceVal = $('.hidden-lbl.source-lbl').text();
          let objArr = {}
          if ((sourceVal.trim()) != "") {
            objArr = { ['source']: sourceVal.trim() }
          }
          let tokenrequestOtions = {
            method: "POST",
            mode: "cors",
            headers: {
              'Authorization': 'Bearer' + get_token,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(objArr),
          };
          fetch(`./wp-json/asd/api/medium`, tokenrequestOtions)
            .then(response => response.json())
            .then(data => { this.setState({ dashboardReport: { ...this.state.dashboardReport, medium_: data.data } }); })
            .catch(error => { console.error(error) })
        }
      });
    };

    const subscribebtn = () => {
      window.location.href = './myaccount';
      localStorage.setItem('profiletab', 1);
      localStorage.setItem('SaveSubscription', 1);
      localStorage.removeItem('subscribeedit_id');

    }

    const leadReturnReasonChange = (reason) => {
      this.setState({ dashboardReport: { ...this.state.dashboardReport, leadReturnReason: reason } });
    }

    const showReportshandleClick = async (e) => {
      this.setState({ dashboardReport: { ...this.state.dashboardReport, isReportVisible: true, currentPage: 1, loading: true } });
      let billingYearValue = (this.state.dashboardReport.selectMonth.getFullYear());
      let billingMonthValue = ("0" + (this.state.dashboardReport.selectMonth.getMonth() + 1)).slice(-2);
      const get_token = localStorage.getItem("token");
      if (this.state.dashboardReport.selectedOption.value != 'external_partner_lead_summary_report') {
        offertypeVal = $('.hidden-lbl.offer-type').text();
      }
      if (this.state.dashboardReport.selectedOption.value != 'credit_lead_return_resason_report') {
        mediumVal = $('.hidden-lbl.medium-lbl').text();
      }
      let objArr =
      {

        'report_type': this.state.dashboardReport.selectedOption.value,
        'page_no': this.state.dashboardReport.page
      }

      if (this.state.dashboardReport.selectedOption.value == 'credit_lead_return_resason_report' || this.state.dashboardReport.selectedOption.value == 'unique_student_report') {
        objArr = { ...objArr, ['tab_type']: this.state.dashboardReport.report_tab_type }
      }    
      if (this.state.dashboardReport.selectedOption.value == 'unique_student_report') {
        let dollarVal = $('.hidden-lbl.dollar-lbl').text();
        if ((dollarVal.trim()) != "") {
          dollarVal = dollarVal.replace(/\$/g, '');
          objArr = { ...objArr, ['dollar_cost']: dollarVal.trim() }
        }
      }
      if (this.state.dashboardReport.selectedOption.value == 'credit_lead_return_resason_report' || this.state.dashboardReport.selectedOption.value == 'unique_student_report') {
        objArr = { ...objArr, ['billing_month']: billingYearValue + billingMonthValue }
      }
      if (this.state.dashboardReport.selectedOption.value != 'credit_lead_return_resason_report' && this.state.dashboardReport.selectedOption.value != 'unique_student_report') {
        objArr = { ...objArr, ['present_date_range']: this.state.dashboardReport.daterangeoption.value }
      }

      if (this.state.dashboardReport.daterangeoption.value) {
        objArr = { ...objArr, ['lead_create_start']: this.state.dashboardReport.startDate.toISOString().split('T')[0] }
        objArr = { ...objArr, ['lead_create_end']: this.state.dashboardReport.endDate.toISOString().split('T')[0] }
      }
      if (this.state.dashboardReport.selectedOption.value != 'credit_lead_return_resason_report' && this.state.dashboardReport.selectedOption.value != 'unique_student_report') {
        if ((mediumVal.trim()) != "") {
          objArr = { ...objArr, ['medium']: mediumVal.trim() }
        }
      }
      if (this.state.dashboardReport.selectedOption.value != 'external_partner_lead_summary_report' && this.state.dashboardReport.selectedOption.value != 'unique_student_report') {
        if ((offertypeVal.trim()) != "") {
          objArr = { ...objArr, ['offer_type']: offertypeVal.trim() }
        }
      }

      let sourceVal = $('.hidden-lbl.source-lbl').text();
      if ((sourceVal.trim()) != "") {
        objArr = { ...objArr, ['source']: sourceVal.trim() }
      }

      const reportRequestOptions = {
        method: 'POST',
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          'Authorization': 'Bearer' + get_token,
        },
        body: JSON.stringify(objArr),
      }
      fetch(`./wp-json/asd/api/report`, reportRequestOptions)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          else if (response.status === 401 || response.status === 403) {
            this.setState({ dashboardReport: { ...this.state.dashboardReport, responsemessage: "You have been logged out, please login again ..!!", loading: false } });
            localStorage.removeItem("token");
            window.location.href = "/asd-login";
          } else if (response.status === 500) {
            this.setState({ dashboardReport: { ...this.state.dashboardReport, responsemessage: "Oh no! Something bad happened. Please come back later..", loading: false } });
            return false
          } else {
            this.setState({ dashboardReport: { ...this.state.dashboardReport, responsemessage: "Something went's wrong. Please try again later", loading: false } });
          }
        })
        .then(data => {
          this.setState({ dashboardReport: { ...this.state.dashboardReport, reportresults: data, pageperdata: data.data.length, loading: false } });

        })
        .catch((error) => {
          this.setState({ dashboardReport: { ...this.state.dashboardReport, responsemessage: "Something went's wrong. Please try again later", loading: false } });
          console.error(error)

        });

      $('.selectvalue-filter').removeClass("hide-filter");
      $('.searchReport').removeClass("hide-filter");

    };
    return (
      <Layout>
        {isAlreadyAuthenticated ? (
          <DashboardViews
            FilterChartfunc={chartFilter}
            filterValue={this.state.dashboard.filterValue}
            chartData={this.state.dashboard.data}
            defaultData={this.state.dashboard.defaultData}
            chartLoad={this.state.dashboard.dataLoad}
            activeFilter={this.state.dashboard.activeFilter}
            activeEle={this.state.dashboard.activeEle}
            chartColumns={this.state.chartColumns}
            chartLoading={this.state.dashboard.loading}
            dashboardReport={this.state.dashboardReport}
            handleChange={handleChange}
            togglePanel={togglePanel}
            presentDatehandleChange={presentDatehandleChange}
            handleDateChange={handleDateChange}
            mediumhandleChange={mediumhandleChange}
            offertypehandleChange={offertypehandleChange}
            sourcehandleChange={sourcehandleChange}
            dollarCosthandleChange={dollarCosthandleChange}
            handleMonthChange={handleMonthChange}
            leadReturnReasonChange={leadReturnReasonChange}
            showReportshandleClick={showReportshandleClick}
            subscribebtn={subscribebtn}
            loadOptions={this.loadOptions}
            dashboardRequest={this.dashboardRequest}
          />

        ) : (
          <Redirect to={{ pathname: "/asd-login" }} />
        )}
        <div>
          {this.state.dashboardReport.selectedOption.value != 'external_partner_lead_summary_report' ? <label className="hidden-lbl offer-type"> {this.state.dashboardReport.offerType != null ? (this.state.dashboardReport.offerType.map((o, i, arr) => <span>{o.value}{i != (arr.length - 1) ? '¤' : ''}</span>)) : ''} </label> : ''}
          <label className="hidden-lbl medium-lbl"> {this.state.dashboardReport.medium != null ? (this.state.dashboardReport.medium.map((o, i, arr) => <span>{o.value}{i != (arr.length - 1) ? '¤' : ''}</span>)) : ''} </label>
          <label className="hidden-lbl source-lbl"> {this.state.dashboardReport.sourceList != null ? (this.state.dashboardReport.sourceList.map((o, i, arr) => <span>{o.value}{i != (arr.length - 1) ? '¤' : ''}</span>)) : ''} </label>
          <label className="hidden-lbl dollar-lbl"> {this.state.dashboardReport.dollarCost != null ? (this.state.dashboardReport.dollarCost.map((o, i, arr) => <span>{o.value}{i != (arr.length - 1) ? '¤' : ''}</span>)) : ''} </label>
        </div>
      </Layout>
    );
  }
}

export default Dashboard;
